import { useMemo, useState } from 'react';
import { defaultTo, filter, includes, isEmpty, propOr, trim } from 'ramda';
import { normalizeStr } from '../pages/helpers/normalizeStr';

const useVariablesSearch = (variables) => {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredVariables = useMemo(() => {
    // `defaultTo` rather than a default parameter: the latter only covers `undefined`,
    // and an explicit `null` would reach `filter` and throw.
    const safeVariables = defaultTo([], variables);
    const term = normalizeStr(trim(defaultTo('', searchTerm)));
    if (isEmpty(term)) return safeVariables;
    return filter(
      (variable) => includes(term, normalizeStr(propOr('', 'key', variable))),
      safeVariables
    );
  }, [variables, searchTerm]);

  return {
    searchTerm,
    setSearchTerm,
    filteredVariables
  };
};

export default useVariablesSearch;
